import { render, staticRenderFns } from "./Cumulatives.vue?vue&type=template&id=53a7856a&"
import script from "./Cumulatives.vue?vue&type=script&lang=js&"
export * from "./Cumulatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports